var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


class CodakitInCartOffer extends HTMLElement {
  constructor() {
    super();
    const fetchOptions = {
      method: "GET",
      headers: {
          "ngrok-skip-browser-warning": "69420"
      },
    };
    var productId = $(this).data('product');
    fetch("/apps/codakit_proxy/in-cart-offer-public/"+productId, fetchOptions)
        .then((response) => response.text())
        .then((data) => {
            $(this).html(data);
    });
  }
}

customElements.define('codakit-in-cart-offer', CodakitInCartOffer);

class CodakitProductCountdown extends HTMLElement {
  constructor() {
    super();
    const fetchOptions = {
      method: "GET",
      headers: {
          "ngrok-skip-browser-warning": "69420"
      },
    };
    var self = this;
    var data = $(self).data('product');
    //check if countdown shout show
    var isShow = false;
    if(data.active == 1 && data.schedule == 0){
      isShow = true;
    }else if(data.active == 1 && data.schedule == 1){
      // Get the current date and time
      const now = new Date();
      // Create a new date object from the given string
      const dateObj = new Date(data.startTime);
      if (dateObj <= now) {
        isShow = true;
      }
    }
    
    if(isShow){
      //$(self).find('.title').html(data.title);
      // Convert the date string to a Date object
      const countdownDate = new Date(data.expires);
      // Get the HTML elements for the timer
      const countdownTimer = $(self).find(".countdown-timer");
      const daysSpan = countdownTimer.find("div:eq(0) span:eq(0)");
      const hoursSpan = countdownTimer.find("div:eq(1) span:eq(0)");
      const minutesSpan = countdownTimer.find("div:eq(2) span:eq(0)");
      const secondsSpan = countdownTimer.find("div:eq(3) span:eq(0)");
      
      // Update the timer every second
      const timer = setInterval(() => {
        const now = new Date().getTime();
        const distance = countdownDate - now;
      
        // Calculate hours, minutes, and seconds left
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
        // Update the HTML elements with the remaining 
        if(days == 0){
          daysSpan.parent().hide();
        }
        daysSpan.text(days.toString().padStart(2, "0"));
        hoursSpan.text(hours.toString().padStart(2, "0"));
        minutesSpan.text(minutes.toString().padStart(2, "0"));
        secondsSpan.text(seconds.toString().padStart(2, "0"));
      
        // If the countdown is over, stop the timer
        if (distance < 0) {
          clearInterval(timer);
          hoursSpan.text("00");
          minutesSpan.text("00");
          secondsSpan.text("00");
          if(data.afterExpires == "hide"){
            $(this).find('.'+data.style).addClass('hidden');
          }else{
            $(this).find('.'+data.style+' .title').html(data.expiresMessage)
            $(this).find('.'+data.style+' .countdown-timer').html("");
            $(this).find('.'+data.style).removeClass('hidden');
          }
        }else{
          $(this).find('.'+data.style).removeClass('hidden');
        }
      }, 1000);
    }
  }
}

customElements.define('codakit-product-countdown', CodakitProductCountdown);

class CodakitStockCountdown extends HTMLElement {
  constructor() {
    super();
    const self = $(this);
    this.targetProduct = self.data('targetProducts');
    this.productId = self.data('product');
    this.variants = self.data('variants');
    this.targetTo = self.data('targetTo');
    const variantSelect = $('.cdz-swatch input');
    const progressBar = self.find('.psc__progress:first');
    const width = progressBar.data('stock-countdown-width');
    progressBar.css("width", width);
    if(this.variants.length > 1){
      variantSelect.on('change', (item) => {
        var title = "";
        var selectedVariants = $('.cdz-swatch.active input');
        selectedVariants.each(function (index, vItem){
          var value = vItem.value;
          if(item.target.name == vItem.name){
            value = item.target.value
          }
          if(index < selectedVariants.length - 1){
            title = title + value + ' / ';
          }else{
            title = title + value;
          }
        });
        const selectedVariant = this.variants.find(variant => variant.title === title);
        if(selectedVariant){
          const inventory = selectedVariant.inventory_quantity > 0 ? selectedVariant.inventory_quantity : 0;
          if(this.variantExists(title)){
            progressBar.css("width", inventory + "%");
            $('#codakit-stock-countdown-inventory').html(inventory);
            $('.codakit-stock-countdown').removeClass('hide');
          }else{
            $('.codakit-stock-countdown').addClass('hide');
            $('#codakit-stock-countdown-inventory').html('');
          }
        }else{
          $('.codakit-stock-countdown').addClass('hide');
          $('#codakit-stock-countdown-inventory').html('');
        }
      });
      if(this.targetTo == 'products'){
        //const variantSelected = $('.cdz-swatch.active input');
        var title = "";
        var selectedVariants = $('.cdz-swatch.active input');
        selectedVariants.each(function (index, vItem){
          var value = vItem.value;
          if(index < selectedVariants.length - 1){
            title = title + value + ' / ';
          }else{
            title = title + value;
          }
        });
        
        if(this.variantExists(title)){
          
          const selectedVariant = this.variants.find(variant => variant.title === title);
          const inventory = selectedVariant.inventory_quantity;
          
          $('#codakit-stock-countdown-inventory').html(inventory);
          $('.codakit-stock-countdown').removeClass('hide');
        }else{
          //$('.codakit-stock-countdown').addClass('hide');
          $('#codakit-stock-countdown-inventory').html('');
        }
      }
    }
  }
  
  variantExists(variantTitle){
    if(this.targetTo == "collection"){
      return true;
    }
    const product = this.targetProduct.find(p => p.id === `gid://shopify/Product/${this.productId}`);
    if (!product) {
      return false;
    }
    return product.variants.some(v => v.title === variantTitle);
  }
}

customElements.define('codakit-stock-countdown', CodakitStockCountdown);

class CodakitPopupContent extends HTMLElement {
  constructor() {
    super();
    var self = this;
    var settings = $(this).data('settings');
    var popupType = settings.popupType;
    $(this).removeClass('hidden');
    this.popup = $(this).cdzPopup(this.dataset);
    var id = this.popup.attr('id');
    $('.cdz-popup .cdz-inner').addClass('codakit-popup template-' + (settings.designTemplate + 1));
    $(this).find('form').on('submit', function(e){
      e.preventDefault();
      const formData = new FormData(e.target);
      if(popupType == "collect_leads"){
        //show loading subscribe button
        var btndom = $(this).find('button');
        btndom.addClass("loading-start");
        btndom.attr("disabled",true);
        
        self.subscribeAction(formData.get('codakit-email'));
      }else if(popupType == "give_discount"){
        var coupon = $(this).find('.coupon span:first');
        if(coupon){
          navigator.clipboard.writeText(coupon.text());
          $(this).find('button.button').text("Copied");
        }
      }else if(popupType == "subscribe_discount"){
        $(this).parent().addClass('hidden');
        $(this).parent().parent().find('.popup-message').removeClass('hidden');
        $(this).parent().parent().find('.popup-coupon').removeClass('hidden');
        var coupon = $(this).find('.coupon span:first');
        if(coupon){
          navigator.clipboard.writeText(coupon.text());
          $(this).find('button.button').text("Copied");
        }
      }
    });

    //show first time
    const lastTriggerPopupTimestamp = self.getCookie('lastTriggerPopupTimestamp');
    if(lastTriggerPopupTimestamp){
      $('.codakit-popup-teaser').removeClass('hidden');
    }
    //settings.repeat = 3;
    self.showPopup(settings);
  }
  subscribeAction(email){
    var self = this;
    const fetchOptions = {
      method: "POST",
      headers: {
          "ngrok-skip-browser-warning": "69420"
      },
    };
    fetch("/apps/codakit_proxy/popup-subscribe/"+email, fetchOptions)
        .then((response) => response.json())
        .then((data) => {
          if(data.success){
            $(self).find('.popup-content').addClass('hidden');
            $(self).find('.popup-message').removeClass('hidden');
            //e.target.reset();
          }
          else{
            alert('false');
          }
    });
  }
  showPopup(settings) {
    var conditions = {
      afterPageLoaded: settings.triggerOpen == "after_page_loaded" ? true : false, // Set to true if the popup should be shown after the page is loaded
      specificTime: settings.triggerOpen == "after_specific_time" ? parseInt(settings.triggerAfterTime)*1000 : false, // Set the specific time in milliseconds (e.g., 5000 for 5 seconds)
      scrollThreshold: settings.triggerOpen == "after_scrolling_down" ? parseInt(settings.scrollThreshold)/100 : false, // Set the scroll threshold as a percentage of the page height (e.g., 0.7 for 70% of the page height)
    };
    var hasScrolled = false;
    var timer;
    var startTime;
    var self = this;
  
    // Function to show the popup
    function showPopup() {
      if (shouldDisplayPopup()) {
        // Check if the cookie exists and retrieve the last trigger timestamp
        const currentTimestamp = Date.now();
        const lastTriggerPopupTimestamp = self.getCookie('lastTriggerPopupTimestamp');
        console.log('show popup');
        if(!lastTriggerPopupTimestamp){
          self.popup.openCdzPopup();
          $('.codakit-popup-teaser').removeClass('hidden');
          self.setCookie('lastTriggerPopupTimestamp', currentTimestamp, 1); // Cookie expires in 1 day
          if(settings.repeat != "0" && !conditions.afterPageLoaded){
            setTimeout(function () {self.showPopup(settings)}, parseInt(settings.repeat)*1000);
          }
        }else{
          if(settings.repeat != "0"){
            // Calculate the time difference in milliseconds
            const currentTimestamp = Date.now();
            const lastTriggerPopupTimestamp = self.getCookie('lastTriggerPopupTimestamp');
            const timeDifference = currentTimestamp - lastTriggerPopupTimestamp;
            // Check if the specified time has elapsed since the last trigger
            if (timeDifference >= parseInt(settings.repeat)*1000) {
              self.popup.openCdzPopup();
              self.setCookie('lastTriggerPopupTimestamp', currentTimestamp, 1); // Cookie expires in 1 day
              if(!conditions.afterPageLoaded){
                setTimeout(function () {self.showPopup(settings)}, parseInt(settings.repeat)*1000);
              }
            }else{
              if(!conditions.afterPageLoaded){
                setTimeout(function () {self.showPopup(settings)}, timeDifference);
              }
            }
          }
        }
      }
    }
  
    // Function to determine if the popup should be displayed based on the conditions
    function shouldDisplayPopup() {
      // Check if the popup should be shown after the page is loaded
      if (conditions.afterPageLoaded && !hasScrolled) {
        return true;
      }
  
      // Check if the popup should be shown after a specific time
      if (conditions.specificTime && !hasScrolled) {
        var currentTime = new Date().getTime();
        var elapsedTime = currentTime - startTime;
        if (elapsedTime >= conditions.specificTime) {
          return true;
        }else{
          timer = setTimeout(function() {
            showPopup();
          }, conditions.specificTime);
          return false;
        }
      }
  
      // Check if the popup should be shown after scrolling down
      if (conditions.scrollThreshold && hasScrolled) {
        return true;
      }
  
      return false;
    }
  
    // Function to handle scroll event
    function handleScroll() {
      if (!hasScrolled) {
        var scrollPosition = window.scrollY || window.pageYOffset;
        var scrollHeight = document.documentElement.scrollHeight;
        var windowHeight = window.innerHeight;
        var scrolledPercentage = scrollPosition / (scrollHeight - windowHeight);
  
        if (scrolledPercentage >= conditions.scrollThreshold) {
          hasScrolled = true;
          showPopup();
          window.removeEventListener('scroll', handleScroll);
        }
      }
    }
  
    // Show the popup initially
    startTime = new Date().getTime();
    window.addEventListener('scroll', handleScroll);
    showPopup();
  }
  // Function to get the value of a cookie
  getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return parseInt(cookie.substring(name.length + 1));
      }
    }
    return null;
  }
    
    // Function to set the value of a cookie
   setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }
}

customElements.define('codakit-popup-content', CodakitPopupContent);
